import React, {FC, ReactElement, useEffect} from 'react';
import {Button, Result} from "antd";
import * as Sentry from "@sentry/react";
import {usePreserveQueryNavigate} from "../components/PreserveQueryLink";

export const NotFoundPage: FC = (): ReactElement => {
    const navigate = usePreserveQueryNavigate();

    useEffect(() => {
        Sentry.captureMessage('404 page');
    }, []);

    return (
        <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => navigate('/')}>Back Home</Button>}
        />
    );
};
